import { Routes, Route, BrowserRouter } from "react-router-dom";
import React, { Suspense, lazy } from "react";
import PublicRoutes from "./PublicRoutes";
import WelcomeRoute from "./WelcomeRoute";
import PrivateRoutes from "./PrivateRoutes";
import RoutePrivateZF from "routes/RoutePrivateZF";
import Loading from "components/Loading/Loading";

// Lazy load route components
const Home = lazy(() => import("pages/Home/Home"));
const WelcomeLan = lazy(() => import("../pages/Home/WelcomeLan"));

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* Rutas prublicas */}
          <Route
            path="/auth/*"
            element={
              <PublicRoutes>
                <Home />
              </PublicRoutes>
            }
          />

          {/* Ruta privadas */}
          <Route
            path="/*"
            element={
              <PrivateRoutes>
                <RoutePrivateZF />
              </PrivateRoutes>
            }
          />
          <Route
            path="/welcome"
            element={
              <WelcomeRoute>
                <WelcomeLan />
              </WelcomeRoute>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRouter;
